var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpyUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#EBF5FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3403_34704)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3403_34704",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3325 10.3301H34.3325V34.3301H10.3325V10.3301Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3403_34704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4102 32.1738C15.4732 32.1738 13.9015 30.6061 13.8968 28.669L13.895 27.9551C16.1518 27.0524 18.6694 27.0524 20.9263 27.9551L20.9236 28.6733C20.9165 30.6087 19.3456 32.1738 17.4102 32.1738Z",
    stroke: "#1C64F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.254 32.1738C25.3169 32.1738 23.7453 30.6061 23.7405 28.669L23.7388 27.9551C25.9956 27.0524 28.5132 27.0524 30.77 27.9551L30.7673 28.6733C30.7603 30.6087 29.1893 32.1738 27.254 32.1738Z",
    stroke: "#1C64F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7856 27.9551H13.895",
    stroke: "#1C64F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9263 27.9551H23.7388",
    stroke: "#1C64F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.77 27.9551H32.8794",
    stroke: "#1C64F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8169 23.7363H13.8481C12.2948 23.7363 11.0356 22.4771 11.0356 20.9238H33.6294C33.6294 22.4771 32.3702 23.7363 30.8169 23.7363Z",
    stroke: "#1C64F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.895 20.9238L15.8603 15.0279C16.3663 13.5101 17.7867 12.4863 19.3866 12.4863C20.3724 12.4863 21.3179 12.8779 22.015 13.575L22.3325 13.8926L22.6501 13.575C23.3472 12.8779 24.2926 12.4863 25.2784 12.4863C26.8784 12.4863 28.2988 13.5101 28.8047 15.0279L30.77 20.9238",
    stroke: "#1C64F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3403_34704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10.3335 10.334)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpyUser);
export default __webpack_public_path__ + "static/media/spy-user.f7dfb1da4ef80bcc0a35f7fe3978ed4c.svg";
export { ForwardRef as ReactComponent };